import { useQuery } from '@tanstack/react-query';
import { useOuraRing } from './oura-ring/useOuraRing';
import { DeviceType } from './types';
import { Device } from '@repo/shared/dtos/devices/DeviceConnectionDto';

interface UseDevicesReturn {
  devices: Device[];
  isLoading: boolean;
  error: Error | null;
  connectDevice: (deviceType: DeviceType) => void;
  isConnecting: boolean;
  connectError: string | null;
}

const fetchUserDevices = async (): Promise<Device[]> => {
  try {
    const response = await fetch('/api/devices');
    if (!response.ok) {
      throw new Error('Failed to fetch devices');
    }
    return response.json();
  } catch (error) {
    console.error('Error fetching devices:', error);
    throw error;
  }
};

export const useDevices = (): UseDevicesReturn => {
  const ouraRing = useOuraRing();

  const {
    data: devices = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['devices'],
    queryFn: fetchUserDevices,
  });

  const connectDevice = (deviceType: DeviceType) => {
    switch (deviceType) {
      case DeviceType.OURA_RING:
        ouraRing.connectToOuraRing();
        break;
      default:
        console.error(`Unknown device type: ${deviceType}`);
        break;
    }
  };

  const isConnecting = ouraRing.isConnecting;
  const connectError = ouraRing.error;

  return {
    devices,
    isLoading,
    error,
    connectDevice,
    isConnecting,
    connectError,
  };
};
